import { encodeFunctionData, parseSignature } from 'viem';
import { permit2ProxyAbi } from '../abi.js';
export const encodeNativePermitData = (tokenAddress, amount, deadline, signature, transactionData) => {
    const { v, r, s } = parseSignature(signature);
    const data = encodeFunctionData({
        abi: permit2ProxyAbi,
        functionName: 'callDiamondWithEIP2612Signature',
        args: [tokenAddress, amount, deadline, Number(v), r, s, transactionData],
    });
    return data;
};
//# sourceMappingURL=encodeNativePermitData.js.map